import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/api-reference.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "api-reference"
    }}>{`API reference`}</h1>
    <h2 {...{
      "id": "extensionversion"
    }}>{`extensionVersion`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`extensionVersion()`}</inlineCode>{` API returns the version of the Profile extension.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=extension-version" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=extension-version" mdxType="Tabs" />
    {/*- React Native
     <Tabs query="platform=react-native&api=extension-version"/> -*/}
    <h2 {...{
      "id": "getuserattributes"
    }}>{`getUserAttributes`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`getUserAttributes()`}</inlineCode>{` API gets the user profile attributes with the given keys.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=get-user-attributes" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=get-user-attributes" mdxType="Tabs" />
    <h2 {...{
      "id": "registerextension"
    }}>{`registerExtension`}</h2>
    <InlineAlert variant="warning" slots="header, text1" mdxType="InlineAlert" />
    <p>{`This API has been deprecated starting in v2.0.0 and removed in v3.0.0 of the Android mobile extension.`}</p>
    <p>{`Use `}<a parentName="p" {...{
        "href": "../mobile-core/api-reference.md#registerextensions"
      }}><inlineCode parentName="a">{`MobileCore.registerExtensions()`}</inlineCode></a>{` API instead.`}</p>
    <p>{`Registers the Profile extension with the Mobile Core extension.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="1" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=register-extension" mdxType="Tabs" />
    <h2 {...{
      "id": "removeuserattribute"
    }}>{`removeUserAttribute`}</h2>
    <InlineAlert variant="warning" slots="header, text1" mdxType="InlineAlert" />
    <p>{`This API has been deprecated starting in v2.0.0 and removed in v3.0.0 of the Android mobile extension.`}</p>
    <p>{`Use `}<a parentName="p" {...{
        "href": "#removeuserattributes"
      }}><inlineCode parentName="a">{`removeUserAttributes`}</inlineCode></a>{` API instead.`}</p>
    <p>{`Deprecated as of 2.0.0. Please use the `}<a parentName="p" {...{
        "href": "#removeuserattributes"
      }}>{`removeUserAttributes`}</a>{` API instead.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="1" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=remove-user-attribute" mdxType="Tabs" />
    <h2 {...{
      "id": "removeuserattributes"
    }}>{`removeUserAttributes`}</h2>
    <p>{`Removes the user profile attributes for the given keys.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=remove-user-attributes" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=remove-user-attributes" mdxType="Tabs" />
    <h2 {...{
      "id": "updateuserattribute"
    }}>{`updateUserAttribute`}</h2>
    <InlineAlert variant="warning" slots="header, text1" mdxType="InlineAlert" />
    <p>{`This API has been deprecated starting in v2.0.0 and removed in v3.0.0 of the Android mobile extension.`}</p>
    <p>{`Use `}<a parentName="p" {...{
        "href": "#updateuserattributes"
      }}><inlineCode parentName="a">{`updateUserAttributes`}</inlineCode></a>{` API instead.`}</p>
    <p>{`Sets the user profile attributes key and value and allows you to create or update a user profile attribute.`}</p>
    <p>{`Remember the following information:`}</p>
    <ul>
      <li parentName="ul">{`If the attribute does not exist, it will be created.`}</li>
      <li parentName="ul">{`If the attribute exists, the value will be updated.`}</li>
      <li parentName="ul">{`A null attribute value removes the attribute.`}</li>
    </ul>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="1" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=update-user-attribute" mdxType="Tabs" />
    <h2 {...{
      "id": "updateuserattributes"
    }}>{`updateUserAttributes`}</h2>
    <p>{`Sets the user profile attributes key and value.`}</p>
    <p>{`Allows you to create/update a batch of user profile attributes:`}</p>
    <ul>
      <li parentName="ul">{`String, Integer, Boolean, Double, Array, Map are valid type of user profile attributes.`}</li>
      <li parentName="ul">{`Custom objects cannot be saved as a `}<inlineCode parentName="li">{`UserProfile`}</inlineCode>{` attribute.`}</li>
      <li parentName="ul">{`If the attribute does not exist, it is created.`}</li>
      <li parentName="ul">{`If the attribute already exists, the value is updated.`}</li>
      <li parentName="ul">{`A null attribute value will remove the attribute.`}</li>
    </ul>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=update-user-attributes" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=update-user-attributes" mdxType="Tabs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      